<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div>
          <div class="label-input">Section Background</div>
          <div class="mb-5 group-item">
            <v-row>
              <v-col cols="12" md="12">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.backgroundColor"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field hide-details v-model="fields.backgroundColor" label="Background Color" />
                </div>
              </v-col>
              <v-col md="6" cols="12">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.top" label="Top Padding" />
                </div>
              </v-col>
              <v-col md="6" cols="12">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <div class="label-input">Header Section</div>
          <div class="group-item mb-5">
            <ckeditor :editor="editor" v-model="fields.header" :config="editorConfig" />
          </div>
        </div>

        <div>
          <div class="d-flex justify-space-between align-center mb-3">
            <div class="label-input">Items</div>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item mb-5">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in fields.listItem" :key="i">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center">
                    <span>Item {{ i + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(i)">
                      <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="">
                    <div class="mb-5">
                      <label class="font-weight-bold">Image</label>
                      <UploadImage
                        @callback="obj => handleUploadImageItem(obj, i)"
                        :image="{ imageSrc: item.image }"
                        :height="`250`"
                        :typeUpload="'image'"
                        @callbackDelete="handleRemoveImageItem(i)"
                      />
                    </div>
                    <div class="mb-5">
                      <label class="font-weight-bold">Text Content</label>
                      <ckeditor :editor="editor" v-model="item.text" :config="editorConfig" />
                    </div>
                    <div class="mb-5">
                      <label class="font-weight-bold">Overlay</label>
                      <v-row>
                        <v-col cols="12" md="6">
                          <div class="d-flex align-center gap-3 mt-4">
                            <input
                              type="color"
                              name="overlay-background-color"
                              style="width: 40px; height: 40px; margin-right: 12px"
                              :value="item.overlay.backgroundColor"
                              @change="event => handleChangeOverlayBackgroundColor(event, i)"
                            />
                            <v-text-field v-model="item.overlay.backgroundColor" label="Background Color" />
                          </div>
                        </v-col>
                        <v-col cols="12" md="6">
                          <div class="">
                            <v-subheader class="pl-0">Opacity</v-subheader>
                            <v-slider
                              v-model="item.overlay.opacity"
                              class="align-center"
                              :step="0.1"
                              :max="1"
                              :min="0"
                              hide-details
                              thumb-label="always"
                            >
                            </v-slider>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div>
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <label for="showButton" style="margin-bottom: 0" class="label-input">Button</label>
            <input type="checkbox" v-model="fields.button.show" id="showButton" />
          </div>
          <div class="group-item mb-5" v-if="fields.button.show">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.button.text" label="Button Text" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.button.link" label="Button Link" />
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="button-background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.button.backgroundColor"
                    @change="handleChangeButtonBackground"
                  />
                  <v-text-field v-model="fields.button.backgroundColor" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="button-text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.button.color"
                    @change="handleChangeButtonTextColor"
                  />
                  <v-text-field v-model="fields.button.color" label="Text Color" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
export default {
  name: 'ItemsSlideB1',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Items Slide B1 Section',
        backgroundColor: '#ffffff',
        padding: {
          top: true,
          bottom: true,
        },
        header: '',
        listItem: [
          {
            overlay: {
              opacity: 0.5,
              backgroundColor: '#000000',
            },
            image: '',
            text: '',
          },
        ],
        button: {
          text: 'SEE BUNDLE OPTIONS',
          backgroundColor: '#281707',
          color: '#ffffff',
          show: true,
          link: '#',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionItemsSlideB1(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeBackgroundColor(event) {
      this.fields.backgroundColor = event.target.value;
    },
    handleAddItem() {
      this.fields.listItem.push({
        overlay: {
          opacity: 0.5,
          backgroundColor: '#000000',
        },
        image: '',
        text: '',
      });
    },
    handleRemoveItem(index) {
      this.fields.listItem.splice(index, 1);
    },
    handleUploadImageItem(obj, index) {
      this.fields.listItem[index].image = obj.imageSrc;
    },
    handleRemoveImageItem(index) {
      this.fields.listItem[index].image = '';
    },
    handleChangeOverlayBackgroundColor(event, index) {
      this.fields.listItem[index].overlay.backgroundColor = event.target.value;
    },
    handleChangeButtonBackground(event) {
      this.fields.button.backgroundColor = event.target.value;
    },
    handleChangeButtonTextColor(event) {
      this.fields.button.color = event.target.value;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 120px;
}
::v-deep .ck-editor__editable {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
